<template>
  <div class="div-box">
    <!-- <div class="div-box" v-loading="vloading" element-loading-text=""> -->
    <div class="div-search">
      <div class="div-search">
        <flex-box title="时间:">
          <el-date-picker v-model="at.time" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:250px" @change="search"
            size="small"></el-date-picker>
        </flex-box>
      </div>
      <div class="div-search">
        <flex-box title="人员：">
          <el-select size="small" v-model="at.user" ref="slectUser" clearable placeholder="请选择用户" style="width:250px"
            @clear="clearUser">
            <el-input size="mini" clearable v-if="treeData1.length != 0" placeholder="输入关键字进行过滤" v-model="filterText"
              style="width: 300px;margin: 0 20px">
            </el-input>
            <br>
            <el-option :label="at.user" :value="at.userkey" class="slectOption">
              <el-tree :data="treeData1" :default-expanded-keys="treeExpandData" ref="UserTree" node-key="key"
                show-checkbox @check="getChecked" :filter-node-method="filterNode">
                <span slot-scope="{ node, data }">
                  <span>{{ node.label }}</span>
                  <span v-if="data.mobile">({{ data.jobName }})</span>
                </span>
              </el-tree>
            </el-option>
          </el-select>
        </flex-box>
      </div>
      <div class="div-search">
        <flex-box title="任务类型：">
          <select-tmpl v-model="at.type" :dataOption="selectOptions.TASK_TYPE" labels="name" values="id" placeholder="请选择"
            size="small"></select-tmpl>
        </flex-box>
      </div>
      <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      <el-button size="small" type="primary" @click="manyExport" v-if="$_has('t-export')">导出全部</el-button>
    </div>
    <div>
      <tableBody :tableData="taskData" :tableNameList="dailyTask.tableColumns" :controller="tableController"
        :diyHeight="'calc(100vh - 200px)'">
        <template slot="type" slot-scope="list">
          <span>{{ _getLabel(list.scope.row, selectOptions.TASK_TYPE, 'type') }}</span>
        </template>
        <template slot="costTime" slot-scope="list">
          <span>{{ list.scope.row.costTime }}h</span>
        </template>
      </tableBody>
      <pagination style="padding:0 10px;margin-top: 10px;" :pageSize="pagesize" :currentPage="currentPage"
        :pageTotal="pageTotal" @handleCurrentChange="handleCurrentChange"></pagination>
    </div>
  </div>
</template>

<script>
import * as api from './taskAPI'
import { DailyTask } from './taskDTO'
import { dateFormat } from "utils/handle";
let employeeIds = []

export default {
  data() {
    return {
      currentUser: JSON.parse(localStorage.getItem("currentUser")), // 当前用户
      taskData: [],
      at: {
        time: '',
        user: '',
        userkey: '',
      },
      options: [],
      taskItem: [],
      dailyTask: DailyTask,
      treeData1: [],
      currentMainKey: '',
      employeeIds: [],
      selectOptions: {},
      tableController: {
        isActive: false,
        selection: false,
        index: true,
        width: 180,
        rowKey: ''
      },
      pagesize: 10,
      currentPage: 1,
      pageTotal: 1,
      treeExpandData: [],
      // vloading: false,
      filterText: ''
    }
  },
  watch: {
    filterText(val) {
      this.$refs.UserTree.filter(val);
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    _getLabel(e, array, key) {
      if (array) {
        return (array.find(item => { return item.id === e[key] }) ? array.find(item => { return item.id === e[key] }).name : e[key]) || ''
      }
    },
    currentClick(data, node, el) {
      // this.showCurrentTool = data.key
      console.log('勾选', data, node, el)
      // if (!this.rightList.find(item => item.key === data.key)) {
      //   this.rightList.push(data)
      // }
    },
    manyExport() {
      let para = {
        current: this.currentPage,
        employeeIdList: this.at.userkey ? this.at.userkey : this.currentUser.id,
        type: this.at.type,
        size: -1
      }
      if (this.at.time) {
        para = {
          current: this.currentPage,
          employeeIdList: this.at.userkey ? this.at.userkey : this.currentUser.id,
          endTime: this.at.time[1],
          startTime: this.at.time[0],
          type: this.at.type,
          size: -1
        }
      }
      api.getDailyTask(para).then(res => {
        if (res.code === 1000) {
          require.ensure([], () => {

            const {
              export_json_to_excel
            } = require('@/utils/excel-out/Export2Excel');
            const tHeader = ['人员', '类别', '任务说明', '耗费时间', '任务时间'];
            const filterVal = ['employeeName', 'type', 'content', 'costTime', 'createTime'];
            const list = res.data.records.map(item => {
              return Object.assign(item, {
                type: this._getLabel(item, this.selectOptions.TASK_TYPE, 'type'),
                costTime: item.costTime + 'h'
              })
            });
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, `任务管理列表`);
          })
        }
      })

    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    getCheckedKeys(data, checked, indeterminate) { //节点选中状态变化的函数
      console.log('选中', data, checked, indeterminate)
    },
    getChecked(checkedNodes, checkedKeys) {
      console.log('勾选选项下', checkedKeys.checkedNodes)
      let keyList = []
      let labelList = []
      let checkNodes = checkedKeys.checkedNodes
      checkNodes.forEach(item => {
        if (item.mobile) {
          keyList.push(item.key)
          labelList.push(item.label)
        }
      })
      this.at.userkey = keyList.join(';')
      this.at.user = labelList.join(';')
      // this.filterText = ''
    },
    search() {
      let para = {
        current: this.currentPage,
        employeeIdList: this.at.userkey ? this.at.userkey : this.currentUser.id,
        type: this.at.type,
        size: this.pagesize
      }

      if (this.at.time) {
        para = {
          current: this.currentPage,
          employeeIdList: this.at.userkey ? this.at.userkey : this.currentUser.id,
          endTime: this.at.time[1],
          startTime: this.at.time[0],
          type: this.at.type,
          size: this.pagesize
        }
      }
      // this.vloading = true
      api.getDailyTask(para).then(res => {
        if (res.code === 1000) {
          this.taskData = res.data.records
          this.pageTotal = res.data.total
        }
        // this.vloading = false
      })
    },
    nodeClick(data) {
      this.currentMainKey = data
    },
    funSlectOptions() {
      api.dictPage({ dictGroupCode: 'DAILY_WEEKLY_TASK_TYPE' }).then(res => {
        if (res.code === 1000) {
          this.selectOptions.TASK_TYPE = res.data.records
          this.search()
        }
      })
      api.getTreeAndPerson().then(res => { // 用户
        this.treeData1 = api.formatTreeAndPerson(res.data)
        this.treeExpandData.push(this.treeData1[0].key)
      })
    },
    clearUser() {
      this.at.userkey = ''
      this.at.user = ''
      this.$refs.UserTree.setCheckedKeys([]);
      api.getTreeAndPerson().then(res => { // 用户
        this.treeData1 = api.formatTreeAndPerson(res.data)
        this.treeExpandData.push(this.treeData1[0].key)
      })
    },
    handleCurrentChange(v) {
      this.currentPage = v
      this.search()
    },
    funGetreportDate(t) {
      let d = new Date
      if (t == undefined || t == '' || t == null) {
        // d = new Date();
      } else {
        d = new Date(t)
      }
      //周日设定的日期时间
      this.at.time = []
      let weekday = d.getDay() // 星期
      d.setTime(d.getTime() - weekday * 24 * 60 * 60 * 1000); // 周日
      let year1, month1, day1;
      [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()]
      let date1 = new Date(year1, month1, day1, 7)
      this.at.time.push(dateFormat(date1))
      //周六设定的日期时间
      let year2, month2, day2
      d.setTime(d.getTime() + (6) * 24 * 60 * 60 * 1000); // 周六
      [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()]
      let date2 = new Date(year2, month2, day2, 7)
      this.at.time.push(dateFormat(date2))
    }
  },
  created() {
    this.funSlectOptions()
    // this.funGetreportDate()
  }
}
</script>

<style scoped>
/* .div-box >>> .el-loading-mask {
  position: absolute;
  z-index: 2000;
  background-color: rgba(255, 255, 255);
  margin: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
} */
.div-box>>>.el-loading-spinner .circular {
  width: 2px;
  height: 2px;
  animation: loading-rotate 2s linear infinite;
  display: none;
}

.div-box>>>.el-loading-spinner {
  background: url(../../assets/loading.gif) no-repeat center top;
  background-size: 200px 200px;
  background-color: rgba(255, 255, 255);
  /* width: 50%;
  height: 50%; */
  width: 200px;
  height: 200px;
  position: relative;
  top: 40%;
  left: 45%;
}

.div-box {
  margin: 20px;
  width: 95%;
}

.div-search {
  float: left;
  margin-right: 20px;
}

.slectOption {
  height: auto;
  overflow: auto;
  background-color: #fff;
}

.custom-tree-node1 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/task-manage/list.vue